import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router';
import { IApp } from './../../../stores/AllStores';

// Component
@inject('store')
@observer
export class Logout extends React.Component<IApp, {}> {
    @observable private loggedOut: boolean = false;
    @observable private logoutError: boolean = false;

    constructor(props: IApp) {
        super(props);

        if (typeof this.props.store !== 'undefined') {
            this.props.store.user.logout().then((response) => {
                this.loggedOut = true;
            }).catch((error) => {
                setTimeout(() => {
                    this.logoutError = true;
                },         1024);
            });
        }
    }

    public render() {
        // Prepare from path
        let from = '/';
        if (typeof this.props.location !== 'undefined' && typeof this.props.location.state !== 'undefined') {
            if (this.props.location.state !== null && typeof this.props.location.state.from !== 'undefined') {
                from = this.props.location.state.from;
            }
        }

        // Render
        if (this.loggedOut) {
            return <Redirect to={{ pathname: '/user/login', state: { from } }} />;
        } else if (this.logoutError) {
            return <Redirect to={{ pathname: '/user/logout', state: { from } }} />;
        } else {
            return (
                <div>
                    <p>Logging out...</p>
                </div>
            );
        }
    }
}

export default Logout;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/user/logout/Logout.tsx